<template>
    <div class="cont_principal">
        <div class="container">
            <div class="row">
                <div class="container-fluid">
                    <p class="pied">E-Portfolio de MORNET Nicolas - contact@nmornet.fr</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Pieds"
    };
</script>

<style>
    .cont_principal {
        margin: 0px;
        padding: 0px;
        background-color: #313131;
        color: white;
    }

    .pied{
	height:100px;
display: flex;
  justify-content: center;
  align-items: center;
    }
</style>
